// @ts-check
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import useFormStyles from '../../common/FormStyle';

const SimpleTextFieldd = ({ type, label = '', name = '', suf = '', placeHolder = '', numberFormated = false, ...props }) => {
    const formStyles = useFormStyles();

    const [editing, setEditing] = useState(false)

    return (
        <>
            {!numberFormated &&
                <TextField className={formStyles.mysitem}
                    variant="outlined"
                    size="small"
                    type={type}
                    {...props}
                    inputProps={{
                        className: formStyles.inputField
                    }}

                />
            }

            {numberFormated && editing &&
                <TextField className={formStyles.mysitem}
                    variant="outlined"
                    size="small"
                    type={type}
                    {...props}
                    inputProps={{
                        className: formStyles.inputField
                    }}
                    onBlur={(e) => {
                        console.log(e.target)
                        setEditing(false)
                        if (props.onBlur) props.onBlur(e)
                    }}
                />
            }
            {numberFormated && !editing &&
                <TextField className={formStyles.mysitem}
                    variant="outlined"
                    size="small"
                    type='text'
                    onFocus={() => setEditing(!editing)}
                    {...props}
                    value={(+props.value).toLocaleString()}
                    inputProps={{
                        className: formStyles.inputField
                    }}
                />
            }

        </>
    )
}

export default SimpleTextFieldd
